import { createSlice } from "@reduxjs/toolkit";

const voteInitialState = {
  votes: [],
};

export const userVoteReducer = createSlice({
  name: "userVote",
  initialState: voteInitialState,
  reducers: {
    setAllVotesForUser: (state, action) => {
      state.votes = action.payload;
    },
  },
});

export const { setAllVotesForUser } = userVoteReducer.actions;

export default userVoteReducer.reducer;
